module.exports={window:"undefined"==typeof window?global:window,global:"undefined"==typeof global?window:global,document:"undefined"==typeof document?{}:document};
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/utils/globals.js
// module id = 894
// module chunks = 0